import { memo } from 'react';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CardMedia from '@mui/material/CardMedia';
import Box from '@mui/material/Box';

import { useTheme } from '@mui/material/styles';
import ProjectLogo from '../../../assets/taytan-icon-header.svg';

import {
    HEADER_HEIGHT,
    SIDEBAR_WIDTH_VAR,
    SIDEBAR_COLLAPSED_WIDTH,
    SIDEBAR_MOTION
} from '../layoutConstants';

type Props = { sidebarToggle: boolean };

function HeaderLogo({ sidebarToggle }: Props) {
    const history = useHistory();
    const theme = useTheme();
    const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));

    if (!isLgUp) return null;

    const onBeck = () => history.push('/');
    return (
        <div
            style={{
                height: HEADER_HEIGHT,
                display: 'flex',
                boxSizing: 'border-box',
                alignItems: 'center',
                // A lighter block on the navy bar in light mode; none in dark,
                // where the bar is the sidebar's colour and a tint is one more shade.
                background: theme.palette.mode === 'dark' ? 'transparent' : 'rgba(255,255,255,.08)',
                // Collapsed, the block is only as wide as the rail below it, so
                // the 20px gutter gives way to whatever centres the mark in the
                // rail. Padding is what positions it — see the note on the mark
                // below for why it is not centred by `margin: auto`.
                paddingLeft: sidebarToggle ? '13px' : '20px',
                paddingRight: sidebarToggle ? '8px' : '20px',
                justifyContent: 'space-between',
                transition: `width ${SIDEBAR_MOTION}, padding ${SIDEBAR_MOTION}`,
                width: sidebarToggle ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH_VAR,
                overflow: 'hidden',
                flexShrink: 0
            }}
        >
            <Box
                title="Taytan CRM system"
                // Always left-aligned. `margin: auto` when collapsed centred the
                // mark in the block as it was AT THAT MOMENT — still 230px wide
                // — so the logo shot right on the first frame and then crawled
                // back left as the block shrank. Left-aligned, it only moves the
                // 7px the padding changes by.
                style={{ display: 'flex', alignItems: 'center' }}
            >
                <IconButton
                    color="primary"
                    size="medium"
                    style={{ padding: '0.133rem', color: 'white' }}
                    onClick={onBeck}
                >
                    <CardMedia
                        component="img"
                        src={ProjectLogo}
                        loading="lazy"
                        style={{
                            width: 'auto',
                            height: '26px',
                            marginRight: 8,
                            opacity: 0.92,
                            filter: 'drop-shadow(0 0 0.5px rgba(255,255,255,0.2))'
                        }}
                    />
                </IconButton>
                <Box
                    style={{
                        fontSize: '17.6px',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        color: 'rgba(255,255,255,0.92)',
                        transition: `opacity ${SIDEBAR_MOTION}`,
                        cursor: 'pointer',
                        ...(sidebarToggle
                            ? { opacity: 0, visibility: 'hidden', overflow: 'hidden', width: 0 }
                            : { width: 'auto' })
                    }}
                    role="button"
                    tabIndex={0}
                    onClick={onBeck}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            onBeck();
                        }
                    }}
                >
                    Taytan
                </Box>
            </Box>
        </div>
    );
}

export default memo(HeaderLogo);
